import FBody from '@/plugins/form/FBody';
import FDate from '@/plugins/form/FDate';
import FTime from '@/plugins/form/FTime';
import FNumber from '@/plugins/form/FNumber';
import FCheckbox from '@/plugins/form/FCheckbox';
import FDays from '@/plugins/form/FDays';
import FSelect from '@/plugins/form/FSelect';

export default class extends FBody {
  dateFrom = new FDate({
    label: 'Дата с',
  });

  dateTo = new FDate({
    label: 'Дата по',
  });

  days = new FDays({
    label: 'Дни',
  });

  time = new FTime({
    label: 'Время',
  });

  tariffs = new FSelect({
    label: 'Тарифы',
    multiple: true,
    options: [
      {
        value: 1,
        label: 'Взрослый билет',
      },
      {
        value: 2,
        label: 'Детский билет',
      },
    ],
  });

  quota = new FNumber({
    label: 'Квота мест',
    min: 1,
  });

  accept = new FCheckbox({
    placeholder: 'ASD',
  });

  id = 0;

  constructor(props = {}) {
    super(props);
    this.setItemDateFrom();
    this.setItemDateTo();
    this.setItemDays();
    this.setItemTime();
    this.setItemTariffs();
    this.setItemQuota();
    this.setItemAccept();
  }

  get data() {
    const data = super.data;
    return {
      Id: this.id,
      DateSince: data.dateFrom ? {
        Format: 'dd.MM.yyyy',
        Serialized: data.dateFrom,
      } : null,
      DateFor: data.dateTo ? {
        Format: 'dd.MM.yyyy',
        Serialized: data.dateTo,
      } : null,
      Time: this.time.getMilliseconds(),
      DaysOfWeek: data.days,
      TariffIds: data.tariffs,
      Quota: data.quota,
      StopSale: !data.accept,
    };
  }

  set data(data) {
    this.id = data.Id || 0;
    this.dateFrom.setString(data?.DateSince?.Serialized || '');
    this.dateTo.setString(data?.DateFor?.Serialized || '');
    this.time.setMilliseconds(data?.Time || 0);
    this.days.set(data?.DaysOfWeek || []);
    this.tariffs.set(data?.TariffIds || []);
    this.quota.set(data?.Quota || 1);
    this.accept.set(!data?.StopSale);
  }

  set(value = {}) {
    this.__set('quota', value.quota, 1);
    this.__set('dateFrom', value.dateFrom, null);
    this.__set('dateTo', value.dateTo, null);
    this.__set('days', value.days, []);
    this.__set('time', value.time, '');
    this.__set('tariffs', value.tariffs, []);
    this.__set('accept', value.accept, true);
    return this;
  }

  setItemDateFrom() {
    this.setItem('dateFrom', this.dateFrom);
  }

  setItemDateTo() {
    this.setItem('dateTo', this.dateTo);
  }

  setItemDays() {
    this.setItem('days', this.days);
  }

  setItemTime() {
    this.setItem('time', this.time);
  }

  setItemTariffs() {
    this.setItem('tariffs', this.tariffs);
  }

  setItemQuota() {
    this.setItem('quota', this.quota);
  }

  setItemAccept() {
    this.setItem('accept', this.accept);
  }

  init() {
    return Promise.resolve();
  }
}
